import { MsalGuard } from '@azure/msal-angular';
import { AuthorityGuard } from '@guards/authority.guard';
import { AuthoritiesDTO } from '@api';
import { ArtRoute } from '@utils/interfaces';

export const routes: ArtRoute[] = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'stock',
    loadComponent: () => import('./pages/inventory/inventory.component').then((m) => m.InventoryComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_ARTICLE_READ],
    },
  },
  {
    path: 'stock/new-artwork',
    loadComponent: () =>
      import('./pages/inventory/new-artwork/new-artwork.component').then((m) => m.NewArtworkComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_ARTICLE_WRITE],
    },
  },
  {
    path: 'artist',
    loadComponent: () => import('./pages/artist/artist.component').then((m) => m.ArtistComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_ARTIST_READ],
    },
  },
  {
    path: 'sell-product',
    loadComponent: () => import('./pages/sell-product/sell-product.component').then((m) => m.SellProductComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_SALES_READ],
    },
  },
  {
    path: 'history',
    loadComponent: () => import('./pages/history/history.component').then((m) => m.HistoryComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_SALES_HISTORY_READ],
    },
  },
  {
    path: 'auction',
    loadComponent: () => import('./pages/auction/auction.component').then((m) => m.AuctionComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    data: {
      authorities: [AuthoritiesDTO.ART_AUCTION_READ, AuthoritiesDTO.ART_AUCTION_WRITE],
    },
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
    canActivate: [MsalGuard, AuthorityGuard],
    children: [
      {
        path: 'tariff-id',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
        data: {
          authorities: [AuthoritiesDTO.ART_CUSTOMS_WRITE],
        },
      },
      {
        path: 'social-insurance-fund',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
        data: {
          authorities: [AuthoritiesDTO.ART_KSK_CONTRIBUTION_WRITE],
        },
      },
      {
        path: 'transport-costs',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
        data: {
          authorities: [AuthoritiesDTO.ART_TRANSPORT_WRITE],
        },
      },
      {
        path: 'medium-list',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
        data: {
          authorities: [AuthoritiesDTO.ART_MEDIUM_WRITE],
        },
      },
      {
        path: 'fidelio-subcodes',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
      },
      {
        path: 'frames-passepartout',
        loadComponent: () => import('./pages/settings/tariff-id/tariff-id.component').then((m) => m.TariffIdComponent),
        canActivate: [MsalGuard, AuthorityGuard],
        data: {
          authorities: [AuthoritiesDTO.ART_FRAME_WRITE],
        },
      },
      {
        path: 'test-data',
        loadComponent: () => import('./pages/settings/test-data/test-data.component').then((m) => m.TestDataComponent),
        canActivate: [MsalGuard],
      },
      {
        path: '**',
        redirectTo: 'tariff-id',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
